/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IState } from '../../../../store/types/StateTypes';

import multiAxisLevelLayoutAccessor from '../../../../store/accessors/multiAxisLevelLayout';

function getChartUIComponent(state :IState) {
    if (!state.metadata) return null;

    const { uiComponents } = state.metadata;
    for (let i = 0; i < uiComponents.length; i += 1) {
        if (uiComponents[i].componentType === 'chart') {
            return uiComponents[i];
        }
    }
    return null;
}

function toSubItem(axisComponent: any) {
    let res;
    if (axisComponent.properties.expanded === true) {
        res = {
            expanded: true,
            measuresLevel: false
        }
    } else if (axisComponent.properties.expanded === false) {
        res = {
            expanded: false,
            measuresLevel: false
        }
    } else {
        res = {
            measuresLevel: true
        }
    }

    return res;
}

export default function genericChartVisualizationStaticPropertiesReducer(staticProperties :any, state: IState, action :any) {

    const multiAxisLayout = multiAxisLevelLayoutAccessor(state);

    const chartUIComponent = getChartUIComponent(state);

    const formattingOptions = {
        xAxisRotation: -45,
        yAxisRotation: 0,
        xAxisStep: 1,
        yAxisStep: 1,
        legend: 'bottom',
        showDataPoints: true,
        advancedProperties: {},
        alignment: 'bottom',
        showMeasureOnValueAxis: true,
        legendBorder: true,
        showSingleMeasuresLabels: true,
        autoScaleFonts: true,
        showScatterLine: false,
        decimalPoint: '.',
        shortMonths: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        showXAxisLabels: true,
        showYAxisLabels: true,
        thousandSeparator: 'None',
        ...(chartUIComponent ? chartUIComponent.properties : {})
    };

    const res = {
        ...staticProperties,
        levelsStructure: multiAxisLayout,
        formattingOptions
    };

    if (chartUIComponent && chartUIComponent.components[0]) {
        res.onyx3ChartColumns = chartUIComponent.components[0].components.map(toSubItem);
    }

    if (chartUIComponent && chartUIComponent.components[1]) {
        res.onyx3ChartRows = chartUIComponent.components[1].components.map(toSubItem);
    }

    res.drilldownEnabled = state.drillDownAllowed && chartUIComponent && chartUIComponent.properties.drilldownEnabled;
    res.drillDown = state.drillDown?.map((drillItem) => drillItem.info);

    return res;
}
